var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconVideosMulticolourLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-videos-multicolour-light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-1264, -889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Multi-color",
    transform: "translate(1120, 279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row-11",
    transform: "translate(0, 610)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/videos/Multicolour/Light",
    transform: "translate(145, 2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.67539062,8.8817842e-16 L3.17539062,5.42857143 L7.13410156,5.42857143 L12.6341016,8.8817842e-16 L8.67539062,8.8817842e-16 Z M2.75,8.8817842e-16 C1.23105469,8.8817842e-16 0,1.21506696 0,2.71428571 L0,5.42857143 L0.260476563,5.42857143 L5.76047656,8.8817842e-16 L2.75,8.8817842e-16 Z M14.0121094,5.42857143 L19.4863281,0.0254464286 C19.4089844,0.0165401786 19.3316406,8.8817842e-16 19.25,8.8817842e-16 L15.5521094,8.8817842e-16 L10.0521094,5.42857143 L14.0121094,5.42857143 Z M21.3855469,1.02591518 L16.9253906,5.42857143 L22,5.42857143 L22,2.71428571 C22,2.07261161 21.7636719,1.49073661 21.3855469,1.02591518 Z",
    id: "Primary",
    fill: "#4C69BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,5.42857143 L22,16.2857143 C22,17.784933 20.7689453,19 19.25,19 L2.75,19 C1.23105469,19 0,17.784933 0,16.2857143 L0,5.42857143 L22,5.42857143 Z M9.63832031,8.89126629 C9.49875781,8.80073214 9.31884766,8.79708482 9.17382812,8.87842857 C9.02790625,8.96117188 8.9375,9.11787946 8.9375,9.28794643 L8.9375,15.1024554 C8.9375,15.2720982 9.02773437,15.4671875 9.17528906,15.5486585 C9.24421094,15.5874304 9.32121094,15.6071429 9.39726562,15.6071429 C9.47890625,15.6071429 9.56484375,15.5816964 9.59921875,15.5337723 L14.1839844,12.6087054 C14.3558594,12.5238839 14.4375,12.2991071 14.4375,12.1761161 C14.4375,12.053125 14.3558594,11.9046875 14.2230859,11.8163333 Z",
    id: "Secondary",
    fill: "#98A6D6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideosMulticolourLight);
export default __webpack_public_path__ + "static/media/icon-videos-multicolour-light.95a61d58.svg";
export { ForwardRef as ReactComponent };